import { render } from "./TabsModalModelo.vue?vue&type=template&id=370bc3c6"
import script from "./TabsModalModelo.vue?vue&type=script&lang=js"
export * from "./TabsModalModelo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__